import {
  ApplicationService,
  type ApplicationDocumentResponse,
} from '@acme/api';
import { Documents } from '@acme/features';
import { downloadFile, Separator } from '@acme/foundation';
import { $documents } from '@entities/application';
import { useUnit } from 'effector-react';
import { Card } from 'flowbite-react';
import { useCallback, useState } from 'react';

export const DocumentsCard = () => {
  const documents = useUnit($documents);
  const [downloadingId, setDownloadingId] = useState<string | null>(null);

  const handleDocumentDownload = useCallback(
    async (d: ApplicationDocumentResponse) => {
      if (!d.id) return;
      setDownloadingId(d.id);
      try {
        const blob = await ApplicationService.getApiV1ApplicationDocument2({
          id: d.id,
        });
        if (blob) {
          downloadFile({
            data: blob,
            fileName: d.name?.trim() || 'document',
            mimeType: 'application/pdf',
          });
        }
      } catch {
        // ignore
      } finally {
        setDownloadingId(null);
      }
    },
    []
  );

  if ((documents?.length ?? 0) === 0) return null;

  return (
    <Card className="divide-y divide-gray-200">
      <h2 className="text-lg font-semibold text-gray-900">
        Документы по сделке
      </h2>
      <Separator className="-mx-6" />
      <Documents
        documents={documents ?? []}
        onDownload={handleDocumentDownload}
        downloadingId={downloadingId}
      />
    </Card>
  );
};
